import React from 'react'
import NavbarMenu from './menu';
import {BaseHeroSection} from '../../../@shared/sections/hero/base'
import {SectionApp} from '../../../@shared/sections/hero/app'
import {HeroGreen} from '../../../@shared/sections/hero/green'
import { Footer } from '../../../@shared/footers';
import { SectionPc } from './intro_pc'
import { SectionApp2 } from './intro_app'
import { HeroSection } from './intro_primary'
import { Mailing } from './mailing'

const ListingPage = () => {

    return (
        <div className="homepage main ">
            <NavbarMenu />  
            <BaseHeroSection />
            <HeroGreen />
            <HeroSection />
            <SectionApp2 />
            <SectionPc />
            <Mailing />
            <SectionApp />
            <Footer /> 
        </div>
    )
}

export default ListingPage

 